import React, { ReactElement } from 'react';
import { DataPointWithValue } from '@src/types/DataPoint';

type DeviceDataPointsSectionProps = {
  translateXCoordinate: number;
  translateYCoordinate: number;
  deviceDataPoints: DataPointWithValue[] | undefined;
  label: string;
};

const textProps = {
  fill: 'currentColor',
  stroke: '#cccccc',
  strokeWidth: '.5',
  textAnchor: 'right',
  fontSize: '8px',
};

function DeviceDataPointsSection(
  props: DeviceDataPointsSectionProps,
): ReactElement {
  const {
    translateXCoordinate,
    translateYCoordinate,
    deviceDataPoints,
    label,
  } = props;

  const checkDataPoints = (dataPoint: DataPointWithValue) =>
    dataPoint?.value ? dataPoint.value : 'non-available';

  return (
    <g>
      <text
        x={translateXCoordinate}
        y={translateYCoordinate - 20}
        {...textProps}
      >
        <tspan x={translateXCoordinate} dy={0}>
          {label}
          <br />
        </tspan>
      </text>

      <rect
        x={translateXCoordinate - 5}
        y={translateYCoordinate - 15}
        width={translateXCoordinate + 150 - (translateXCoordinate - 5)}
        height={(deviceDataPoints?.length || 0) * 15 + 10}
      />

      <text x={translateXCoordinate} y={translateYCoordinate} {...textProps}>
        {deviceDataPoints?.map(
          (dataPoint: DataPointWithValue, index: number) => (
            <React.Fragment key={index}>
              <tspan x={translateXCoordinate} dy={index === 0 ? 0 : 15}>
                {`${dataPoint.displayName}:`}
              </tspan>

              <tspan x={translateXCoordinate + 50} textAnchor='start'>
                {checkDataPoints(dataPoint)}
              </tspan>
            </React.Fragment>
          ),
        )}
      </text>
    </g>
  );
}

export default DeviceDataPointsSection;
